export default __webpack_public_path__ + "static/media/walletconnect.dfa25e47.svg";